// State argument is not application state, only the state this reducer is responsible for
function dynamicComs(state = "", action) {
  switch (action.type) {
    case "SET_DYNAMIC_COMS":
      return action.value;
    default:
      return state;
  }
}

export default dynamicComs;
